import { CustomerType } from "./CustomerType.js";

export enum PaymentType {
	GoPayApplePay = "GoPayApplePay",
	GoPayGPay = "GoPayGPay",
	GoPayPaymentCard = "GoPayPaymentCard",
	GoPayQRCode = "GoPayQRCode",
	OnDelivery = "OnDelivery",
	OnInvoice = "OnInvoice",
}

export const paymentTypePerCustomerType = {
	[CustomerType.B2c]: [
		PaymentType.GoPayApplePay,
		PaymentType.GoPayGPay,
		PaymentType.GoPayPaymentCard,
		PaymentType.GoPayQRCode,
		PaymentType.OnDelivery,
	] as const,
	[CustomerType.B2b]: [PaymentType.OnDelivery, PaymentType.OnInvoice] as const,
} satisfies Record<CustomerType, PaymentType[]>;

export type B2cPaymentType = (typeof paymentTypePerCustomerType)["B2c"][number];
export type B2bPaymentType = (typeof paymentTypePerCustomerType)["B2b"][number];
